import { render, staticRenderFns } from "./AdvSummaryList.vue?vue&type=template&id=33a1602c&scoped=true"
import script from "./AdvSummaryList.vue?vue&type=script&lang=js"
export * from "./AdvSummaryList.vue?vue&type=script&lang=js"
import style0 from "./AdvSummaryList.vue?vue&type=style&index=0&id=33a1602c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a1602c",
  null
  
)

export default component.exports